import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import WechatAuthorization from '@components/Share/WechatAuthorization';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import SignleSignOnModel from '../models/SignleSignOnModel';

const WechatSSO = ({fields, isLogin}) => {
  const [inputData, setInputData] = useState('');

  useEffect(() => {
    setInputData(new SignleSignOnModel().getData(fields || {}));
  }, []);

  //INFO: add 'className' to custom styles for button WechatAuthorization'. Props 'state' use(optional) to nagative link you want if login success;
  return inputData && !isLogin ? (
    <div className='sigle-sign-on-wechat'>
      <WechatAuthorization
        appID={inputData['App ID'].value}
        redirectUri={inputData['Redirect Uri'].value}
        // state={window.location.href}
      >
        <Text field={inputData['Login Label']}/>  
      </WechatAuthorization>
    </div>
  ) : '';
};

WechatSSO.propTypes = {
  fields: PropTypes.object,
  isLogin: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  dataUser: state.singleSignOnReducer.userInfoReducer?.dataUser || [],
  isLogin: state.singleSignOnReducer.userInfoReducer?.isLogin ?? false,
});

export default connect(mapStateToProps)(WechatSSO);
